export default __webpack_public_path__ + "static/media/external-icon.94cbed74.svg";